import axios from 'axios';
export const updateInvoices = async (values, dependencies) => {
  const {
    invoiceCreatedUserId,
    prefillingData,
    setShowSubmit,
    setLoading,
    toast,
    t,
    navigate,
    calculateTotalFileSize,
    convertFileToBase64,
    diffInDates,
    getOtherArticlesUnit,
    getArticleNumber,
    isArticleTaxFree,
    requiredFlags,
    allowancePerDaySweden,
    AMOUNT_PER_UNIT,
    NEW_ARTICLES,
    globalData,
    calculatedAmounts,
    expenditureSum,
    holidaySavingFee,
    pension,
    holidaySavings,
    vat,
    anyArrayHasValue,
    otherArticlesData,
    seperatedUserCalculations,
    user,
    pensionAmount,
    dueDate,
    userDetails,
  } = dependencies;
  const currencyGlobalValue = globalData?.currencies?.find(
    (item) => item.description === values?.currency
  )?.globalValue;

  let readers = [];
  const fileItems = [];
  const totalWorkingDates = [];
  const amountPerFreelancers = [];
  let freelancersPerDate = [];

  values?.invoiceFile?.forEach((item) => {
    if (item instanceof FileList) {
      Array.from(item)?.forEach((file) => {
        fileItems?.push(file);
        const reader = new FileReader();
        const fileReadPromise = new Promise((resolve, reject) => {
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
        });
        reader.readAsDataURL(file);
        readers.push(fileReadPromise);
      });
    }
  });

  values?.invoiceFile?.forEach((item) => {
    if (item?.fileContent || item?.uploadfileForInvoice) {
      fileItems.push({
        fileName: item?.fileName,
        fileContent: item?.fileContent || item?.uploadfileForInvoice,
        filesUploadid: item?.filesUploadid,
        invoiceApprovalId: item?.invoiceApprovalId,
        userId: item?.userId,
      });
    }
  });

  const fileBytes = await Promise.all(readers);
  let file = [];
  let indexValue = 0;
  fileItems.forEach((item) => {
    if (item?.fileContent) {
      file.push({
        fileName: item?.fileName,
        fileContent: item?.fileContent,
        filesUploadid: item?.filesUploadid,
        invoiceApprovalId: item?.invoiceApprovalId,
        userId: item?.userId,
      });
    } else {
      file.push({
        fileName: item?.name,
        fileContent: fileBytes[indexValue].split(',')[1],
        userId: item?.userId,
      });
      indexValue++;
    }
  });

  if (values?.invoiceHours?.length > 1) {
    values?.invoiceHours?.forEach((items) => {
      Object.keys(items)?.forEach((date) => {
        freelancersPerDate.push(items[date].amount * items[date].units);
      });
      if (Object.keys(items).length === freelancersPerDate.length) {
        let total = 0;
        freelancersPerDate?.forEach((items) => {
          total += items;
        });
        amountPerFreelancers.push(total);
        freelancersPerDate = [];
      }
    });
  }

  const loginedUserIndex = values?.freelancer?.findIndex((item) => item?.userId === invoiceCreatedUserId);
  let adjustedList;
  if (loginedUserIndex !== -1) {
    adjustedList = [...values?.freelancer];
    const removedItem = adjustedList.splice(loginedUserIndex, 1)[0];
    adjustedList.unshift(removedItem);
  } else {
    adjustedList = [...values?.freelancer];
    const userObject = { userId: invoiceCreatedUserId };
    adjustedList.unshift(userObject);
  }

  values?.invoiceHours?.forEach((items, index) => {
    Object.keys(items)?.forEach((date) => {
      const [year, month, day] = date?.split('-');
      totalWorkingDates.push({
        id: 0,
        workingDate: `${year}-${month}-${day}`,
        dateId: date,
        number: items[date].units,
        unit: items[date].article.unit,
        amountPerUnit: items[date].amount,
        customWorkingDescription: items[date].customWorkingDescription || '',
        amount: items[date].amount * items[date].units,
        articleNumber: items[date].article?.articleNumber,
        workingDescription: items[date].workingDescription || '',
        houseworkType: items[date].houseworkType ? items[date].houseworkType.value : '',
        userId: adjustedList[index]?.userId,
        workingHour: items[date].article?.articleNumber === AMOUNT_PER_UNIT.HourlyWages ? items[date].units : 0,
        vat: vat || Number(items[date].article?.vat),
        foodAllowance: 0,
      });
    });
  });

  if (anyArrayHasValue) {
    for (const [key, value] of Object.entries(otherArticlesData)) {
      if (value?.length > 0) {
        for (const [index, item] of value.entries()) {
          let fileBase64 = null;
          const uploadFile = item.data?.uploadFile;
          if (uploadFile) {
            if (typeof uploadFile === 'string') {
              fileBase64 = uploadFile;
            } else if (uploadFile?.[0] instanceof File) {
              try {
                fileBase64 = await convertFileToBase64(uploadFile[0]);
              } catch (error) {
                toast.error("One or more uploaded files could not be processed. Please try again.");
                setLoading(false);
                return;
              }
            }
          } else if (item.data?.fileContent) {
            fileBase64 = item.data.fileContent;
          }

          const isPdfAttachedToInvoice =
            (item?.data?.isMileagePdfShowToCustomer === '1' &&
              item?.data?.isAisPdfShowToCustomer === '1' &&
              item?.data?.isAosPdfShowToCustomer === '1' &&
              item?.data?.isTravelPdfShowToCustomer === '1' &&
              item?.data?.isMaterialPdfShowToCustomer === '1') ||
            item?.data?.isPdfAttachedToInvoice;

          let date;
          if (item.key === NEW_ARTICLES.MILEAGE) {
            date = item?.data?.travelDate;
          } else if (item.key === NEW_ARTICLES.TRAVEL) {
            date = item?.data?.travelExpDate;
          } else if (item.key === NEW_ARTICLES.MATERIAL_VAT) {
            date = item?.data?.dateOfPurchase;
          }

          const isMileage = item.key === NEW_ARTICLES.MILEAGE;
          const isAllowance = item.key === NEW_ARTICLES.ALLOWANCE_OUT || item?.key === NEW_ARTICLES.ALLOWANCE_IN;

          const amountPerUnitSek = isMileage
            ? AMOUNT_PER_UNIT.MILEAGE
            : isAllowance
              ? item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key]
              : Number(item?.value);

          const number = isMileage
            ? item?.data?.distance
            : isAllowance
              ? diffInDates(
                item?.key,
                item?.data?.tripEndedDateIs || item?.data?.tripEndedDate,
                item?.data?.tripStartedDateIs || item?.data?.tripStartedDate,
                item?.data?.tripEndedDateOs || item?.data?.tripEndedDate,
                item?.data?.tripStartedDateOs || item?.data?.tripStartedDate
              )
              : "1";

          const parseValue = (value, defaultValue = 0) =>
            isNaN(parseFloat(value)) ? defaultValue : Number(value);

          const currencyFactor = parseValue(currencyGlobalValue, 1);
          let amountPerUnit = 0;

          if (item.key === NEW_ARTICLES.MILEAGE) {
            amountPerUnit = AMOUNT_PER_UNIT.MILEAGE / currencyFactor;

          } else if (item.key === NEW_ARTICLES.ALLOWANCE_OUT || item.key === NEW_ARTICLES.ALLOWANCE_IN) {
            const allowancePerDay = item?.data?.allowancePerDay || item?.data?.amountPerUnitSek || allowancePerDaySweden[item?.key];
            amountPerUnit = parseValue(allowancePerDay) / currencyFactor;

          } else {
            amountPerUnit = (isNaN(parseFloat(item?.value)) ? 0 : Number(item?.value)) / currencyFactor;

          }
          totalWorkingDates.push({
            id: 0,
            dateId: item?.id,
            workingDate: date ? date : item?.data?.workingDate?.split('T')?.[0],
            number: number,
            unit: getOtherArticlesUnit(item, 'unit'),
            amountPerUnitSek: amountPerUnitSek,
            amountPerUnit: amountPerUnit,
            articleNumber: getArticleNumber(item),
            workingDescription: item?.label,
            houseworkType: '',
            workingHour: 0,
            isTaxFreeArticle: isArticleTaxFree(item),
            isArticleShownInInvoice:
              requiredFlags.every((flag) => item.data?.[flag] === '1') || item?.data?.isArticleShownInInvoice,
            isPdfAttachedToInvoice: isPdfAttachedToInvoice,
            tripStartedPlace: item?.data?.tripStartedPlace,
            tripEndedPlace: '',
            distance: item?.data?.distance || 0,
            country:
              item?.key === NEW_ARTICLES.ALLOWANCE_OUT ? item?.data?.country : item?.key === NEW_ARTICLES.ALLOWANCE_IN ? 'Sweden' : '',
            allowancePerDay: item?.data?.allowancePerDay || item?.data?.amountPerUnitSek,
            reasonForTrip: item?.data?.reasonForTrip || '',
            carRegistrationNo: item?.data?.carRegistrationNo || '',

            tripStartedDate:
              item?.data?.tripStartedDate?.split('T')[0] ||
              (item?.key === NEW_ARTICLES.ALLOWANCE_OUT ? item?.data?.tripStartedDateOs : item?.data?.tripStartedDateIs),
            tripEndedDate:
              item?.data?.tripEndedDate?.split('T')[0] ||
              (item?.key === NEW_ARTICLES.ALLOWANCE_OUT ? item?.data?.tripEndedDateOs : item?.data?.tripEndedDateIs),

            amount: isNaN(parseFloat(item?.valueInSelectedCurrency))
              ? 0.0
              : Number(item?.valueInSelectedCurrency),

            totalDayOfTravels: diffInDates(
              item?.key,
              item?.data?.tripEndedDateIs || item?.data?.tripEndedDate,
              item?.data?.tripStartedDateIs || item?.data?.tripStartedDate,
              item?.data?.tripEndedDateOs || item?.data?.tripEndedDate,
              item?.data?.tripStartedDateOs || item?.data?.tripStartedDate
            ),
            allowanceDestination: item?.data?.destination || item?.data?.allowanceDestination || '',
            expenseCategory: '',
            fileName: item.data?.uploadFile?.[0]?.name || item.data?.fileName || null,
            fileContent: fileBase64 ? fileBase64 : null,
            userId: item.userId || 0,
            amountInSek: Number(item?.value),
            isHalfDay: item?.data?.isHalfDay,
            vat: item?.data?.vat != null ? Number(item?.data?.vat) : vat,
            foodAllowance: item?.data?.totalFoodRate || 0,
          });
        }
      }
    }
  }

  let invoiceFreelancer;

  if (!values?.isFixed) {
    if (values.freelancer && values.freelancer?.length) {
      invoiceFreelancer = values.freelancer?.map((item) => ({
        amount: 0,
        userId: item.userId,
      }));
      const isInvoiceCreatorIncluded = values.freelancer?.some((freelancer) => freelancer.userId === Number(invoiceCreatedUserId));
      if (!isInvoiceCreatorIncluded) {
        invoiceFreelancer.push({
          amount: 0,
          userId: Number(invoiceCreatedUserId),
        });
      }
    } else {
      invoiceFreelancer = [
        {
          amount: 0,
          userId: Number(invoiceCreatedUserId),
        },
      ];
    }
  } else {
    if (values.freelancer && values.freelancer.length) {
      invoiceFreelancer = values.freelancer.map((item, index) => {
        if (item.userId === Number(invoiceCreatedUserId)) {
          return {
            amount: amountPerFreelancers[0],
            userId: item.userId,
          };
        } else {
          return {
            amount: amountPerFreelancers[index + 1] || 0,
            userId: item.userId,
          };
        }
      });

      const isInvoiceCreatorIncluded = values.freelancer.some((freelancer) => freelancer.userId === Number(invoiceCreatedUserId));

      if (!isInvoiceCreatorIncluded) {
        invoiceFreelancer.push({
          amount: amountPerFreelancers[0],
          userId: Number(invoiceCreatedUserId),
        });
      }
    } else {
      invoiceFreelancer = [
        {
          amount: Number(values?.amount),
          userId: Number(invoiceCreatedUserId),
        },
      ];
    }
  }

  try {
    const { getInvoiceData } = prefillingData;

    setShowSubmit(false);
    setLoading(true);

    const workingDatesFileContent = totalWorkingDates.map((date) =>
      date.fileContent ? { fileContent: date.fileContent } : { fileContent: '' }
    );

    const totalFileSize =
      calculateTotalFileSize(file) + calculateTotalFileSize(workingDatesFileContent);

    if (totalFileSize > 5 * 1024 * 1024) {
      toast.error(t("Please ensure that the total size of all uploaded files does not exceed 5 MB"));
      return;
    }

     let invoiceFreelancerArr = [];
      if (values?.freelancer && values?.freelancer.length > 0) {
         // Remove duplicates from freelancer array based on userId while preserving original indices
         const uniqueFreelancers = values.freelancer.filter((freelancer, index, self) => 
           index === self.findIndex(f => f.userId === freelancer.userId)
         );

          // const filteredFreelancers = values.freelancer.filter(f => f.userId !== user?.userId);
        const isMultipleFreelancers = values?.freelancer.length > 1;
         
        const  filteredFreelancers = uniqueFreelancers.filter(f => f.userId !== user?.userId);
      invoiceFreelancerArr = filteredFreelancers.map((freelancer, idx) => {
        // Find the original index of this freelancer in the original array to maintain pension mapping
        const originalIndex = values.freelancer.findIndex(f => f.userId === freelancer.userId);
        const currentPensionAmount = pensionAmount && typeof pensionAmount === "object" ? pensionAmount[originalIndex] : pensionAmount;
        const shouldUsePrefillingData = !currentPensionAmount || currentPensionAmount === 0;
        
        // If pensionAmount > 0, set pension to true, otherwise use existing logic
        let finalPension;
        if (currentPensionAmount && currentPensionAmount > 0) {
          finalPension = true;
        } else if (shouldUsePrefillingData && isMultipleFreelancers) {
          finalPension = prefillingData?.getInvoiceData?.freelancer?.[originalIndex]?.pension;
        } else {
          finalPension = pension && typeof pension === "object" ? pension[originalIndex] : pension;
        }
        
        return {
          amount: values?.isFixed
            ? amountPerFreelancers[originalIndex] +
              (Number(values.amount) -
                amountPerFreelancers.reduce((x, y) => x + y, 0)) /
                values.invoiceHours?.length
            : 0,
          userId: freelancer.userId,
          pension: finalPension,
          pensionAmount: shouldUsePrefillingData && isMultipleFreelancers 
              ? prefillingData?.getInvoiceData?.freelancer?.[originalIndex]?.pensionAmount 
              : currentPensionAmount,
          PensionFeePercentage: Array.isArray(seperatedUserCalculations) && seperatedUserCalculations[originalIndex] ? seperatedUserCalculations[originalIndex].pensionPercentage : undefined,
          holidaySavings: values?.holidaySavings && typeof values.holidaySavings === "object" ? values.holidaySavings[originalIndex] : values?.holidaySavings,
          holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === "object" ? holidaySavingFee[originalIndex] : holidaySavingFee,
        };
      });

       const mainUserPensionAmount = pensionAmount && typeof pensionAmount === "object" ? pensionAmount[0] : pensionAmount;
        const shouldUsePrefillingDataForMainUser = !mainUserPensionAmount || mainUserPensionAmount === 0;
        
        // If mainUserPensionAmount > 0, set pension to true, otherwise use existing logic
        let finalMainUserPension;
        if (mainUserPensionAmount && mainUserPensionAmount > 0) {
          finalMainUserPension = true;
        } else if (shouldUsePrefillingDataForMainUser && isMultipleFreelancers) {
          finalMainUserPension = prefillingData?.getInvoiceData?.freelancer?.[0]?.pension;
        } else {
          finalMainUserPension = pension && typeof pension === "object" ? pension[0] : pension;
        }
      // Add main user as first element
      invoiceFreelancerArr.unshift({
        amount: values?.isFixed
      ? amountPerFreelancers[0] +
          (Number(values.amount) -
            amountPerFreelancers.reduce((x, y) => x + y, 0)) /
            values.invoiceHours?.length
        : 0,
          userId: userDetails?.userId,
          pension: finalMainUserPension,
          pensionAmount: shouldUsePrefillingDataForMainUser && isMultipleFreelancers 
            ? prefillingData?.getInvoiceData?.freelancer?.[0]?.pensionAmount 
            : mainUserPensionAmount,
          PensionFeePercentage: Array.isArray(seperatedUserCalculations) && seperatedUserCalculations[0] ? seperatedUserCalculations[0].pensionPercentage : undefined,
          holidaySavings: values?.holidaySavings && typeof values.holidaySavings === "object" ? values.holidaySavings[0] : values?.holidaySavings,
          holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === "object" ? holidaySavingFee[0] : holidaySavingFee,
        });
        
        // Remove duplicates from final array based on userId
        invoiceFreelancerArr = invoiceFreelancerArr.filter((freelancer, index, self) => 
          index === self.findIndex(f => f.userId === freelancer.userId)
        );
      } else {
         const singleUserPensionAmount = pensionAmount && typeof pensionAmount === "object" ? pensionAmount[0] : pensionAmount;
        const shouldUsePrefillingDataForSingleUser = !singleUserPensionAmount || singleUserPensionAmount === 0;
         let finalSingleUserPension;
        if (singleUserPensionAmount && singleUserPensionAmount > 0) {
          finalSingleUserPension = true;
        } else if (shouldUsePrefillingDataForSingleUser) {
          finalSingleUserPension = prefillingData?.getInvoiceData?.freelancer?.[0]?.pension;
        } else {
          finalSingleUserPension = pension && typeof pension === "object" ? pension[0] : pension;
        }
        invoiceFreelancerArr = [
          {
        amount: 0,
        userId: 0,
        pension: finalSingleUserPension,
        pensionAmount: shouldUsePrefillingDataForSingleUser 
          ? prefillingData?.getInvoiceData?.freelancer?.[0]?.pensionAmount 
          : singleUserPensionAmount,
        PensionFeePercentage: Array.isArray(seperatedUserCalculations) && seperatedUserCalculations[0] ? seperatedUserCalculations[0].pensionPercentage : undefined,
        holidaySavings: values?.holidaySavings && typeof values.holidaySavings === "object" ? values.holidaySavings[0] : values?.holidaySavings,
        holidaySavingsFee: holidaySavingFee && typeof holidaySavingFee === "object" ? holidaySavingFee[0] : holidaySavingFee,
          },
        ];
      }


    let pensionToSend = pension;
      if (pension && typeof pension === "object") {
        const keys = Object.keys(pension);
        if (keys.length > 1) {
          pensionToSend = false;
        } else if (keys.length === 1) {
          pensionToSend = pension[0];
        }
      }

       let holidaySavingsToSend = holidaySavings;
      if (holidaySavings && typeof holidaySavings === "object") {
        const keys = Object.keys(holidaySavings);
        if (keys.length > 1) {
          holidaySavingsToSend = false;
        } else if (keys.length === 1) {
          holidaySavingsToSend = holidaySavings[0];
        }
      }

       let holidaySavingsFeeToSend = holidaySavingFee;
      if (holidaySavingFee && typeof holidaySavingFee === "object") {
        const keys = Object.keys(holidaySavingFee);
        if (keys.length > 1) {
          holidaySavingsFeeToSend = 0;
        } else if (keys.length === 1) {
          holidaySavingsFeeToSend = holidaySavingFee[0];
        }
      }

        let pensionAmountToSend =  pensionAmount;
      if ( pensionAmount && typeof  pensionAmount === "object") {
        const keys = Object.keys( pensionAmount);
        if (keys.length > 1) {
          pensionAmountToSend = 0;
        } else if (keys.length === 1) {
          pensionAmountToSend =  pensionAmount[0];
        }
      }

    const formatDueDate = (dateStr) => {
      if (!dateStr) return null;
      
      // Handle already formatted date strings
      if (typeof dateStr === 'string' && dateStr.includes('T')) {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return null;
        }
        return date.toISOString().replace('Z', '+07:00');
      }
      
      // Handle date strings without time
      try {
        const date = new Date(dateStr + 'T12:00:00');
        if (isNaN(date.getTime())) {
          return null;
        }
        return date.toISOString().replace('Z', '+07:00');
      } catch (error) {
        console.warn('Invalid date format for dueDate:', dateStr);
        return null;
      }
    };

    const res = await axios.put('/admin/invoice/edit-invoices', {
      invoiceNumber: getInvoiceData ? getInvoiceData?.invoiceNumber : 0,
      sendInvoice: 1,
      showHours: true,
      vat: values?.vat,
      pension: pensionToSend,
      amount: parseFloat(values?.amount),
      isFixed: values?.isFixed,
      currency: values?.currency,
      brfNo: values?.brfNo || '',
      registerAssignment: false,
      showDates: values?.showDates,
      house: values?.house || false,
      holidaySavings: holidaySavingsToSend,
      description: values?.description,
      taxValue: calculatedAmounts?.tax,
      totalToPay: calculatedAmounts?.net,
      rutDeduction: values?.rutDeduction,
      rootDeduction: values?.rootDeduction,
      file: file.length > 0 ? file : null,
      dueDate: formatDueDate(dueDate),
      expressPayout: (globalData?.customer?.paymentTerm == '45' || globalData?.customer?.paymentTerm == '60' || globalData?.customer?.accountType === 1 || (globalData?.customer?.country !== "Sweden" && globalData?.customer?.accountType !== 1)) ? false : values?.expressPayout,
      workingHours: [...totalWorkingDates],
      email: values?.selectedCustomer.email,
      apartment: values?.apartment || false,

      pensionFee: pension ? seperatedUserCalculations[0]?.pensionPercentage : 0,

      holidaySavingsFee: holidaySavings ? holidaySavingsFeeToSend : 0,
      tax: parseInt(globalData.tax.globalValue, 10),
      rotApartmentNo: values?.rotApartmentNo || '',

      pensionAmount: pensionAmountToSend || 0,
      customerId: values?.selectedCustomer.customerId,
      expenditureForMaterialsAndToolsTaxFreeAmount: expenditureSum ? expenditureSum : 0,
      holidaySavingsAmount: calculatedAmounts?.holidayPayAmount,
      amountIncVat: Math.round(calculatedAmounts?.amountIncludingVat),

      secondaryEmailAddress: values?.selectedCustomer.secondaryEmailAddress,
      multipleFreelancer: values?.freelancer && values?.freelancer.length > 0 ? true : false,

      currencyRate: globalData.currencies.find((item) => item.description === values.currency).globalValue,
      invoiceFreelancer: invoiceFreelancerArr,

    });
    if (res?.status === 200) {
      toast.success(t('Invoice updated successfully'));
      setLoading(false);
      navigate('/dashboard/invoices');
    } else {
      toast.error(t('Something went wrong, Please try again'));
    }
  } catch (err) {
    const errorMessage = err?.response?.data?.message || err?.message || 'Something went wrong, Please try again';
    toast.error(t(errorMessage));
    console.log('error in updating invoice', err);
    setShowSubmit(false);
    setLoading(false);
  } finally {
    setShowSubmit(false);
    setLoading(false);
  }
};